import { Box, Grid, Typography } from "@material-ui/core";
import React from "react";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { Checkbox,InputLabel,Select,ListItem } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import CustomInput from "../../../../../../Components/CustomInput";

const useStyles = makeStyles((theme) => ({
  formCheck: {
    "& .MuiTypography-body1": {
      fontSize: "16px",
      fontFamily: "Open Sans",
    },
  },
}));
let first = true;
function CafTabContent(props) {
  React.useEffect(() => {
    // setLoading(true);
    return () => {
      first = true;
    };
  }, []);
  const classes = useStyles();
  const [answerData, setAnswerData] = React.useState({});
  console.log("additionalSection", props.additionalSection, props.subHeading);
  return (
    <Box>
      <Grid container direction="row">
        <Box my={3} width="1">
          {props.pageData.length > 0 &&
            props.pageData.map((option) => {
              return (
                <Grid container direction="row">
                  <Grid
                    item
                    xs={6}
                    style={{
                      marginTop: "8px",
                      textAlign: "justify",
                      paddingRight: "20px",
                    }}
                  >
                    <Typography variant="h2" style={{ color: "#232323" }}>
                      <Box mb={2} fontWeight="fontWeightBold">
                        {option.field_value}
                      </Box>
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="h2" style={{ color: "#232323" }}>
                      <Box mb={2}>{option.answer}</Box>
                    </Typography>
                  </Grid>
                </Grid>
              );
            })}
          {props.subHeading.length > 0 &&
            props.subHeading.map((option) => {
              return (
                <Grid container direction="row">
                  <Grid
                    item
                    xs={12}
                    style={{
                      marginTop: "8px",
                      textAlign: "justify",
                      paddingRight: "20px",
                    }}
                  >
                    <Typography
                      variant="h2"
                      style={{
                        fontWeight: "bold",
                        padding: "12px",
                        backgroundColor: "#F2F2F2",
                      }}
                    >
                      <Box mb={2} fontWeight="fontWeightBold">
                        {option.sub_heading}
                      </Box>
                    </Typography>
                  </Grid>
                  {option.coaching_agreement_form_fields.map((row) => (
                    <React.Fragment>
                      <Grid container direction="row">
                        <Grid
                          item
                          xs={12}
                          style={{
                            marginTop: "8px",
                            textAlign: "justify",
                            paddingRight: "20px",
                          }}
                        >
                          <Typography variant="h2" style={{ color: "#232323" }}>
                            <Box mb={2} fontWeight="fontWeightBold">
                              {row.field_value}
                            </Box>
                          </Typography>
                        </Grid>
                       <Grid item xs={6}>
                          {(row.field_type === "text_area" || row.field_type === "Text area" ) && (
                            <CustomInput
                              disabled
                              id="first_name"
                              multiline
                              rows="4"
                              variant="outlined"
                              defaultValue={row.answer}
                            />)}
                     
                           {( (row.field_type === "text" || row.field_type === "Text") &&  <CustomInput
                              disabled
                              id="first_name"
                              variant="outlined"
                              defaultValue={row.answer}
                            />
                          )}
                        </Grid>
                      </Grid>
                    </React.Fragment>
                  ))}
                 {option.objectives.map((row1, i) => (
                               <React.Fragment> 
                                  <Grid
                                 container
                                 direction="row"
                                 alignItems="flex-start"
                                 style={{ marginBottom: 20, marginTop: 20, backgroundColor: '#F2F2F2' }}
                               >
                                 <Grid
                                   item
                                   xs={10}
                                 >
                                   <InputLabel>
                                     <Typography variant="subtitle1" style={{ fontWeight: "bold", padding: '12px', color: "#4D4F5C", }}>
                                       {row1.objective_name}
                                     </Typography>
                                   </InputLabel>
                                 </Grid>
                               </Grid>
                               {row1.coaching_agreement_form_fields && row1.coaching_agreement_form_fields !== undefined && row1.coaching_agreement_form_fields.map((row, i) => (
                                <Grid
                                  container
                                  direction="row"
                                  alignItems="flex-start"
                                  style={{ marginBottom: 20, marginTop: 20, }}
                                >
                                  <Grid
                                    item
                                    xs={
                                      (row.field_value === "description") ? 10 : row.field_type === "Text area" ? 12 : 5}
                                  >
                                    <InputLabel
                                      className={classes.labelText}
                                      style={{ padding: '12px' }}
                                    >
                                      <Typography variant="h2">
                                        {row.field_value}
                                      </Typography>
                                    </InputLabel>
                                   
                                  </Grid>
                                  <Grid
                              item
                              style={{ paddingTop: row.field_type === "Text area" ? '20px' : '' }}
                              xs={
                                row.field_value === "description" ? 0 : row.field_type === "Text area" ? 9 : 4
                              }
                            >
                              <Grid
                                container
                                direction="row"
                                alignItems="center"
                                style={{ marginBottom: 20 }}
                              >
                                <Grid item xs={12}>
                                  {(row.field_type === "text" || row.field_type === "Text") &&
                                    (row.field_type !== "Description" || row.field_type !== "description")&& (
                                      <CustomInput
                                        disabled
                                        id={row.id}
                                        variant="outlined"
                                        defaultValue={row.answer}
                                       
                                        // value={userData.first_name}
                                      />
                                    )}
                                  {(row.field_type === "text_area" || row.field_type === "Text area" || row.field_type !== "Description")
                                    && (
                                      <CustomInput
                                        disabled
                                        multiline
                                        rows="4"
                                        id={row.id}
                                        variant="outlined"
                                        defaultValue={row.answer}
                                        parentcall={3}
                                        // value={userData.first_name}
                                      />
                                    )}
                                  {(row.field_type === "dropdown" || row.field_type === "Dropdown" || row.field_type === "Drop down") && (
                                    <Select
                                      helperText="Please select Location"
                                      variant="outlined"
                                      id={row.id}
                                      disabled
                                      defaultValue={row.answer}
                                      style={{ width: "100%" }}
                                      inputProps={{
                                        id: "outlined-age-native-simple",
                                      }}
                                    ></Select>
                                  )}

                                </Grid>
                              </Grid>
                            </Grid>
                            {row.organisation_metrics && row.organisation_metrics !== undefined && row.organisation_metrics.map((row2,ind) => {
                              //  if (first && ind === 0) {
                              //   console.log("running for row")
                              //   setAnswerData({
                              //     [row.id]: [row.answer && row.answer.split(",")]
                              //       .flatMap((el) => el)
                              //       .reduce(
                              //         (acc, x) => acc.concat(+x),
                              //         []
                              //       ),
                              //   });

                              //   first = false;
                              // }
                            
                                    return (
                                      <Grid item xs={6}>
                                        <FormControlLabel
                                          control={
                                            <Checkbox
                                              name={row2.field_value}
                                              color="primary"
                                              id={row2.id}
                                              disabled
                                           
                                              checked={row?.answer?.split(",")?.includes(`${row2?.id}`)}
                                              // checked={answerData[
                                              //   row.id
                                              // ]?.includes(row2.id)}
                                            />
                                          }
                                          //   onChange={handleCheckboxValue}
                                          label={<Typography variant="h2">{row2.name}</Typography>}
                                        //   className={classes.paper}
                                        />
                                        

                                      </Grid>

                                    );
                                  })}
                                  {(row.compteencies) && row.compteencies.map((item, index) => (
                                    <ListItem key={index}>
                                      <Checkbox
                                        disabled
                                        id={row.id}
                                        // checked={state[item.value]}
                                        // onChange={handleChangeWO}
                                        name={item.name}
                                      />
                                      <Typography variant="h2">{item.name}</Typography>
                                    </ListItem>
                                  ))}
                                </Grid>
                              ))}
                                </React.Fragment>
                              ))}
                </Grid>
              );
            })}
        </Box>
      </Grid>
    </Box>
  );
}

export default CafTabContent;
